import _ from 'lodash'

import { CardRewardsEarnRates } from "../../types/CardRewardsEarnRates";

export const deepApply = (obj: CardRewardsEarnRates, fn: (_: number) => number) => {
  return _.cloneDeepWith(obj, (value) => {
    if (_.isInteger(value)) {
      return fn(value);
    }
  });
};


export function flattenObject(
  obj: Record<string, any>,
  parentKey: string = '',
  result: Record<string, any> = {}
): Record<string, any> {
  _.forEach(obj, (value, key) => {
    const newKey = parentKey ? `${parentKey}.${key}` : key;
    if (
      _.isObject(value) &&
      !Array.isArray(value) &&
      !('card' in value && value.card)
    ) {
      flattenObject(value, newKey, result); // Recurse into nested object
    } else {
      result[newKey] = value; // Assign the value to the dot-notated key
    }
  });
  return result;
}